/**
 * Copyright (C) 2020 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import styled from 'styled-components';
import StyledProps from '../theme/AppThemeInterface';

export const PanelLabel = styled.span`
  color: white;
  font-family: ${({ theme }: StyledProps) => theme.appFontFamily};
  font-size: 12px;
  letter-spacing: 0.5px;
  margin-left: 15px;
`;
